import React from "react"
import Icon from "@ant-design/icons"

const BurgerSVG = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.71429 6.46429H21.2857C21.6802 6.46429 22 6.14451 22 5.75V3.96429C22 3.56978 21.6802 3.25 21.2857 3.25H2.71429C2.31978 3.25 2 3.56978 2 3.96429V5.75C2 6.14451 2.31978 6.46429 2.71429 6.46429ZM2.71429 13.6071H21.2857C21.6802 13.6071 22 13.2874 22 12.8929V11.1071C22 10.7126 21.6802 10.3929 21.2857 10.3929H2.71429C2.31978 10.3929 2 10.7126 2 11.1071V12.8929C2 13.2874 2.31978 13.6071 2.71429 13.6071ZM2.71429 20.75H21.2857C21.6802 20.75 22 20.4302 22 20.0357V18.25C22 17.8555 21.6802 17.5357 21.2857 17.5357H2.71429C2.31978 17.5357 2 17.8555 2 18.25V20.0357C2 20.4302 2.31978 20.75 2.71429 20.75Z"
      fill="#4F4B4A"
    />
  </svg>
)

const Burger = props => <Icon component={BurgerSVG} {...props} />

export default Burger
